import React, { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Grid, TextField, Table, TableHead, TableBody, TableRow, TableCell, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import CommitteeMember from '../forms/member';
import { handleDateTimeToDate } from '../services/date';

function Detail({ match }) {
    /** Vars for caching data, might be overkill but I like the idea, especially if we can work it into the app frameowrk */
    const CACHED_NAME = 'committee';
    const CACHED_SCHEMA = {
        "id": 0,
        "name": "string",
        "term": "string",
        "appointments": "string",
        "meetingSchedule": "string",
        "meetingLocation": "string",
        "website": "string",
        "committeeMembers": [
          {
            "id": 0,
            "committeeID": 0,
            "personID": 0,
            "yearAppointed": 0,
            "membershipExpires": "",
            "membershipType": "",
            "person": {
              "id": 0,
              "name": ""
            }
          }
        ]
      };
    //useful for testing
    //localStorage.removeItem(CACHED_NAME);
    const CACHED_ITEM = JSON.parse(localStorage.getItem(CACHED_NAME)) || CACHED_SCHEMA;
    //See Press-Release-Manager Edit for example of how to see if persistent snackbar is open and close it on navigation
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    /** Navigation var, to know which object we're editing */
    const committeeID = match.params.id;
    /** Main Object of the form */
    const [committee, setCommittee] = useState(parseInt(committeeID) === CACHED_ITEM.id ? CACHED_ITEM : CACHED_SCHEMA);
    const [editMember, setEditMember] = useState(-1);

    // API Get Data fn
    const handleGetCommitteeData = useCallback(() => {
        fetch(`https://api2.auburnalabama.org/committee/${committeeID}`, { credentials: 'include' })
            .then((response) => { if (response.ok) return response.json(); else throw new Error('Data Download Error'); })
            .then((committee) => {
                Object.keys(committee).forEach(key => { if (committee[key] === null) committee[key] = '' });//remove null's (React treats components with value=null as 'uncontrolled' for some reason)
                //manipulate committee member data
                committee.committeeMembers.forEach(member => {
                    Object.keys(member).forEach(key => { if (member[key] === null) member[key] = ''});
                    member.membershipExpires = handleDateTimeToDate(member.membershipExpires);
                });
                //for (var i = 0; i < committee.committeeMembers.length; i++) {
                    //Object.keys(committee.committeeMembers[i]).forEach(key => { if (committee.committeeMembers[i][key] === null) committee.committeeMembers[i][key] = '' });
                    //manipulate committee member expire
                    //committee.committeeMembers[i].membershipExpires = handleDateTimeToDate(committee.committeeMembers[i].membershipExpires);
                //}
                setCommittee(committee);
                localStorage.setItem(CACHED_NAME, JSON.stringify(committee));
            })
            .catch((err) => console.error(err));
    }, [committeeID]);

    // INITIAL LOAD
    useEffect(() => {
        handleGetCommitteeData();
    }, [handleGetCommitteeData]);

    // FORM CONSISTENCY
    const handleFieldChange = event => { setCommittee({ ...committee, [event.target.name]: event.target.value }) };

    // SAVE COMMITTEE FUNCTION
    const handleEditSubmit = (event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        fetch(`https://api2.auburnalabama.org/committee/${committee.id}`, { credentials: 'include', headers: { 'Content-Type': 'application/json' }, method: 'PUT', body: JSON.stringify(committee) })
            .then((response) => { if (response.ok) return; else throw new Error(); })
            .then(() => enqueueSnackbar('Saved', { variant: 'success' }))
            .catch((e) => {
                enqueueSnackbar('Save FAILED', { variant: 'error', persist: true, action: (key) => (
                    <Button onClick={() => closeSnackbar(key)}>Dismiss</Button>
                ) });
            });
    }

    // MEMBER EDIT - OPEN
    const handleOpenEditMember = (event) => {
        console.log(event.currentTarget);
        setEditMember(event.currentTarget.getAttribute('memberindex'));
    }
    // MEMBER EDIT - CLOSE
    const handleCloseEditMember = (event) => {
        setEditMember(-1);
    }
    // VIEW
    return (
        <React.Fragment>
            <section>
                <header>
                    <h2>Committee Detail <small>{committee.name}</small></h2>
                </header>
                <form id="CommitteeEditForm" method="PUT" action={`https://api2.auburnalabama.org/committee/${committee.id}`} onSubmit={handleEditSubmit}>
                    <input type="hidden" id="CommitteeID" name="ID" value={committee.id}></input>
                    <Grid container spacing={2} alignItems="center">
                        {/* Name */}
                        <Grid item xs={12}>
                            <TextField id="CommitteeName" type="text" name="name" className="fullWidth" required
                                        label="Name"
                                        value={committee.name} onChange={handleFieldChange}></TextField>
                        </Grid>
                        {/* Term */}
                        <Grid item xs={12}>
                            <TextField id="CommitteeTerm" type="text" name="term" className="fullWidth" required
                                        label="Term"
                                        value={committee.term} onChange={handleFieldChange}></TextField>
                        </Grid>
                        {/* Appointments */}
                        <Grid item xs={12}>
                            <TextField id="CommitteeAppointments" type="text" name="appointments" className="fullWidth" required
                                        label="Appointments"
                                        value={committee.appointments} onChange={handleFieldChange}></TextField>
                        </Grid>
                        {/* MeetingSchedule */}
                        <Grid item xs={12}>
                            <TextField id="CommitteeMeetingSchedule" type="text" name="meetingSchedule" className="fullWidth" required
                                        label="Meeting Schedule"
                                        value={committee.meetingSchedule} onChange={handleFieldChange}></TextField>
                        </Grid>
                        {/* MeetingLocation */}
                        <Grid item xs={12}>
                            <TextField id="CommitteeMeetingLocation" type="text" name="meetingLocation" className="fullWidth"
                                        label="Meeting Location"
                                        value={committee.meetingLocation} onChange={handleFieldChange}></TextField>
                        </Grid>
                        {/* Website */}
                        <Grid item xs={12}>
                            <TextField id="CommitteeWebsite" type="text" name="website" className="fullWidth"
                                        label="Website"
                                        value={committee.website} onChange={handleFieldChange}></TextField>
                        </Grid>
                        {/* Submit */}
                        <Grid item xs={12}>
                            <Button variant="contained" size="small" type="submit" style={{float: 'right'}}>
                                <SaveIcon></SaveIcon>&nbsp;Save
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </section>
            <br/>
            <section>
                <header className="withActions">
                    <h2>Committee Members <small>{committee.name}</small></h2>
                    <Button variant="text" size="small" color="inherit" onClick={handleOpenEditMember}>
                        <AddIcon /> Add
                    </Button>
                </header>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Duration</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {committee.committeeMembers.map((member, i) => {
                            return <TableRow key={member.id} memberindex={i} onClick={handleOpenEditMember} className="selectable">
                                    <TableCell>{member.person.name}</TableCell>
                                    <TableCell align="right">{`${member.yearAppointed}—${member.membershipExpires}`}</TableCell>
                                </TableRow>
                        })}
                    </TableBody>
                </Table>
                <Dialog open={Boolean(editMember !== -1)} onClose={handleCloseEditMember} aria-labelledby="member-edit-dialog-title">
                    <DialogTitle id="member-edit-dialog-title">Edit Member</DialogTitle>
                    <DialogContent>
                        <CommitteeMember member={committee.committeeMembers[editMember]} committeeID={committeeID} onClose={handleCloseEditMember} onSave={handleGetCommitteeData}></CommitteeMember>
                    </DialogContent>
                </Dialog>
            </section>
        </React.Fragment>
    )
}

export { Detail }
